import type { IModuleMenuI18n, Lang } from '@platform/core/types';
import { moduleBundle } from '@platform/i18n';

/**
 * Рядки власного меню модуля з пакета мовою `lang` (`menu.groups` / `menu.items` верхнього рівня i18n пакета за англійським підписом);
 * undefined, доки пакет не завантажено (тоді — підписи визначення).
 */
export function moduleMenuLabels(lang: Lang, moduleKey: string): IModuleMenuI18n | undefined {
  return (moduleBundle(lang, moduleKey) as { menu?: IModuleMenuI18n } | undefined)?.menu;
}
